import { ISku } from '../../common/types/ISku'
import { PlannerName } from '../enums/PlannerNameEnum'
import { ISkusQueryResult } from '../types/ISkusQueryResult'
import { ApiClient } from './apiClient'

export const getSkus = async (
  apiClient: ApiClient,
  storeId: number,
): Promise<ISku[]> =>
  (
    await apiClient.get<ISkusQueryResult>(
      PlannerName.Bakery,
      `skus/bakery/${storeId}`,
    )
  ).skus

export const getRangedSkusByStore = async (
  apiClient: ApiClient,
  storeId: number,
  date: string,
  onlyShowActive: boolean = true,
): Promise<ISku[]> => {
  const params = new URLSearchParams({
    date: date,
    onlyShowActive: String(onlyShowActive),
  })
  return (
    await apiClient.get<ISkusQueryResult>(
      PlannerName.Bakery,
      `skus/ranged/${storeId}?${params.toString()}`,
    )
  ).skus
}
